import React from 'react';
import { IconProps } from './types';

export const EighteenPlusIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M 20 4 A 16 16 0 1 0 36 20"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <path
      d="M 32 3 V 11 M 28 7 H 36"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <text
      x="18"
      y="26"
      textAnchor="middle"
      fontSize="17"
      fontWeight="700"
      fill="currentColor"
      fontFamily="'Poppins', sans-serif"
    >
      18
    </text>
  </svg>
);
